// ORTHO

import Fixed from "../resources/Fixed/fixed.png";
import Fixed2x from "../resources/Fixed/fixed@2x.png";
import Fixed3x from "../resources/Fixed/fixed@3x.png";
import Fixed4x from "../resources/Fixed/fixed@4x.png";
import Fixed_bg from "../resources/Fixed/fixed-bg.png";
import Fixed_bg2x from "../resources/Fixed/fixed-bg@2x.png";
import Fixed_bg3x from "../resources/Fixed/fixed-bg@3x.png";
import Fixed_bg4x from "../resources/Fixed/fixed-bg@4x.png";

import Aligner from "../resources/Aligner/aligner.png";
import Aligner2x from "../resources/Aligner/aligner@2x.png";
import Aligner3x from "../resources/Aligner/aligner@3x.png";
import Aligner4x from "../resources/Aligner/aligner@4x.png";
import Aligner_bg from "../resources/Aligner/aligner-bg.png";
import Aligner_bg2x from "../resources/Aligner/aligner-bg@2x.png";
import Aligner_bg3x from "../resources/Aligner/aligner-bg@3x.png";
import Aligner_bg4x from "../resources/Aligner/aligner-bg@4x.png";

import Expansion from "../resources/Expansion/expansion.png";
import Expansion2x from "../resources/Expansion/expansion@2x.png";
import Expansion3x from "../resources/Expansion/expansion@3x.png";
import Expansion4x from "../resources/Expansion/expansion@4x.png";
import Expansion_bg from "../resources/Expansion/expansion-bg.png";
import Expansion_bg2x from "../resources/Expansion/expansion-bg@2x.png";
import Expansion_bg3x from "../resources/Expansion/expansion-bg@3x.png";
import Expansion_bg4x from "../resources/Expansion/expansion-bg@4x.png";

import Model from "../resources/Model/model.png";
import Model2x from "../resources/Model/model@2x.png";
import Model3x from "../resources/Model/model@3x.png";
import Model4x from "../resources/Model/model@4x.png";
import Model_bg from "../resources/Model/model-bg.png";
import Model_bg2x from "../resources/Model/model-bg@2x.png";
import Model_bg3x from "../resources/Model/model-bg@3x.png";
import Model_bg4x from "../resources/Model/model-bg@4x.png";

import Wire from "../resources/Wire/wire.png";
import Wire2x from "../resources/Wire/wire@2x.png";
import Wire3x from "../resources/Wire/wire@3x.png";
import Wire4x from "../resources/Wire/wire@4x.png";
import Wire_bg from "../resources/Wire/wire-bg.png";
import Wire_bg2x from "../resources/Wire/wire-bg@2x.png";
import Wire_bg3x from "../resources/Wire/wire-bg@3x.png";
import Wire_bg4x from "../resources/Wire/wire-bg@4x.png";

import Overig from "../resources/Overig_old/overig.png";
import Overig2x from "../resources/Overig_old/overig@2x.png";
import Overig3x from "../resources/Overig_old/overig@3x.png";
import Overig4x from "../resources/Overig_old/overig@4x.png";

// DENTAL

import Bridge from "../resources/Bridge/bridge.png";
import Bridge2x from "../resources/Bridge/bridge@2x.png";
import Bridge3x from "../resources/Bridge/bridge@3x.png";
import Bridge4x from "../resources/Bridge/bridge@4x.png";
import Bridge_bg from "../resources/Bridge/bridge-bg.png";
import Bridge_bg2x from "../resources/Bridge/bridge-bg@2x.png";
import Bridge_bg3x from "../resources/Bridge/bridge-bg@3x.png";
import Bridge_bg4x from "../resources/Bridge/bridge-bg@4x.png";

import Crown from "../resources/Crown/crown.png";
import Crown2x from "../resources/Crown/crown@2x.png";
import Crown3x from "../resources/Crown/crown@3x.png";
import Crown4x from "../resources/Crown/crown@4x.png";
import Crown_bg from "../resources/Crown/crown-bg.png";
import Crown_bg2x from "../resources/Crown/crown-bg@2x.png";
import Crown_bg3x from "../resources/Crown/crown-bg@3x.png";
import Crown_bg4x from "../resources/Crown/crown-bg@4x.png";

import Full from "../resources/Full/full.png";
import Full2x from "../resources/Full/full@2x.png";
import Full3x from "../resources/Full/full@3x.png";
import Full4x from "../resources/Full/full@4x.png";
import Full_bg from "../resources/Full/full-bg.png";
import Full_bg2x from "../resources/Full/full-bg@2x.png";
import Full_bg3x from "../resources/Full/full-bg@3x.png";
import Full_bg4x from "../resources/Full/full-bg@4x.png";

import FullUpper from "../resources/FullDentureUpper/full-upper.png";
import FullUpper2x from "../resources/FullDentureUpper/full-upper@2x.png";
import FullUpper3x from "../resources/FullDentureUpper/full-upper@3x.png";
import FullUpper4x from "../resources/FullDentureUpper/full-upper@4x.png";
import FullUpper_bg from "../resources/FullDentureUpper/full-upper-bg.png";
import FullUpper_bg2x from "../resources/FullDentureUpper/full-upper-bg@2x.png";
import FullUpper_bg3x from "../resources/FullDentureUpper/full-upper-bg@3x.png";
import FullUpper_bg4x from "../resources/FullDentureUpper/full-upper-bg@4x.png";

import FullLower from "../resources/FullDentureLower/full-lower.png";
import FullLower2x from "../resources/FullDentureLower/full-lower@2x.png";
import FullLower3x from "../resources/FullDentureLower/full-lower@3x.png";
import FullLower4x from "../resources/FullDentureLower/full-lower@4x.png";
import FullLower_bg from "../resources/FullDentureLower/full-lower-bg.png";
import FullLower_bg2x from "../resources/FullDentureLower/full-lower-bg@2x.png";
import FullLower_bg3x from "../resources/FullDentureLower/full-lower-bg@3x.png";
import FullLower_bg4x from "../resources/FullDentureLower/full-lower-bg@4x.png";

import ImplantBridge from "../resources/ImplantBridge/implantbridge.png";
import ImplantBridge2x from "../resources/ImplantBridge/implantbridge@2x.png";
import ImplantBridge3x from "../resources/ImplantBridge/implantbridge@3x.png";
import ImplantBridge4x from "../resources/ImplantBridge/implantbridge@4x.png";
import ImplantBridge_bg from "../resources/ImplantBridge/implantbridge-bg.png";
import ImplantBridge_bg2x from "../resources/ImplantBridge/implantbridge-bg@2x.png";
import ImplantBridge_bg3x from "../resources/ImplantBridge/implantbridge-bg@3x.png";
import ImplantBridge_bg4x from "../resources/ImplantBridge/implantbridge-bg@4x.png";

import ImplantCrown from "../resources/ImplantCrown/implantcrown.png";
import ImplantCrown2x from "../resources/ImplantCrown/implantcrown@2x.png";
import ImplantCrown3x from "../resources/ImplantCrown/implantcrown@3x.png";
import ImplantCrown4x from "../resources/ImplantCrown/implantcrown@4x.png";
import ImplantCrown_bg from "../resources/ImplantCrown/implantcrown-bg.png";
import ImplantCrown_bg2x from "../resources/ImplantCrown/implantcrown-bg@2x.png";
import ImplantCrown_bg3x from "../resources/ImplantCrown/implantcrown-bg@3x.png";
import ImplantCrown_bg4x from "../resources/ImplantCrown/implantcrown-bg@4x.png";

import Partial from "../resources/Partial/partial.png";
import Partial2x from "../resources/Partial/partial@2x.png";
import Partial3x from "../resources/Partial/partial@3x.png";
import Partial4x from "../resources/Partial/partial@4x.png";
import Partial_bg from "../resources/Partial/partial-bg.png";
import Partial_bg2x from "../resources/Partial/partial-bg@2x.png";
import Partial_bg3x from "../resources/Partial/partial-bg@3x.png";
import Partial_bg4x from "../resources/Partial/partial-bg@4x.png";

import DentalOverig_bg from "../resources/Overig/dental-generic-v1-bg.png";
import DentalOverig_bg2x from "../resources/Overig/dental-generic-v1-bg@2x.png";
import DentalOverig_bg3x from "../resources/Overig/dental-generic-v1-bg@3x.png";
import DentalOverig_bg4x from "../resources/Overig/dental-generic-v1-bg@4x.png";

import Dot from "../resources/Dot/dot.png";


// ---------------------------------------------------------------------------
// Single source of truth: iconType → { fg, bg } image sets
// Both getImageSetForIconType and getBackgroundImageSetForIconType read from
// here so they can never be out of sync.
// ---------------------------------------------------------------------------

const IMAGE_SETS = {
  ImplantBridge: {
    fg: { src: ImplantBridge,    srcSet: `${ImplantBridge2x} 2x, ${ImplantBridge3x} 3x, ${ImplantBridge4x} 4x` },
    bg: { src: ImplantBridge_bg, srcSet: `${ImplantBridge_bg2x} 2x, ${ImplantBridge_bg3x} 3x, ${ImplantBridge_bg4x} 4x` },
  },
  Bridge: {
    fg: { src: Bridge,    srcSet: `${Bridge2x} 2x, ${Bridge3x} 3x, ${Bridge4x} 4x` },
    bg: { src: Bridge_bg, srcSet: `${Bridge_bg2x} 2x, ${Bridge_bg3x} 3x, ${Bridge_bg4x} 4x` },
  },
  ImplantCrown: {
    fg: { src: ImplantCrown,    srcSet: `${ImplantCrown2x} 2x, ${ImplantCrown3x} 3x, ${ImplantCrown4x} 4x` },
    bg: { src: ImplantCrown_bg, srcSet: `${ImplantCrown_bg2x} 2x, ${ImplantCrown_bg3x} 3x, ${ImplantCrown_bg4x} 4x` },
  },
  Crown: {
    fg: { src: Crown,    srcSet: `${Crown2x} 2x, ${Crown3x} 3x, ${Crown4x} 4x` },
    bg: { src: Crown_bg, srcSet: `${Crown_bg2x} 2x, ${Crown_bg3x} 3x, ${Crown_bg4x} 4x` },
  },
  PartialDenture: {
    fg: { src: Partial,    srcSet: `${Partial2x} 2x, ${Partial3x} 3x, ${Partial4x} 4x` },
    bg: { src: Partial_bg, srcSet: `${Partial_bg2x} 2x, ${Partial_bg3x} 3x, ${Partial_bg4x} 4x` },
  },
  FullDenture: {
    fg: { src: Full,    srcSet: `${Full2x} 2x, ${Full3x} 3x, ${Full4x} 4x` },
    bg: { src: Full_bg, srcSet: `${Full_bg2x} 2x, ${Full_bg3x} 3x, ${Full_bg4x} 4x` },
  },
  FullDentureUpper: {
    fg: { src: FullUpper,    srcSet: `${FullUpper2x} 2x, ${FullUpper3x} 3x, ${FullUpper4x} 4x` },
    bg: { src: FullUpper_bg, srcSet: `${FullUpper_bg2x} 2x, ${FullUpper_bg3x} 3x, ${FullUpper_bg4x} 4x` },
  },
  FullDentureLower: {
    fg: { src: FullLower,    srcSet: `${FullLower2x} 2x, ${FullLower3x} 3x, ${FullLower4x} 4x` },
    bg: { src: FullLower_bg, srcSet: `${FullLower_bg2x} 2x, ${FullLower_bg3x} 3x, ${FullLower_bg4x} 4x` },
  },
  Wire: {
    fg: { src: Wire,    srcSet: `${Wire2x} 2x, ${Wire3x} 3x, ${Wire4x} 4x` },
    bg: { src: Wire_bg, srcSet: `${Wire_bg2x} 2x, ${Wire_bg3x} 3x, ${Wire_bg4x} 4x` },
  },
  Fixed: {
    fg: { src: Fixed,    srcSet: `${Fixed2x} 2x, ${Fixed3x} 3x, ${Fixed4x} 4x` },
    bg: { src: Fixed_bg, srcSet: `${Fixed_bg2x} 2x, ${Fixed_bg3x} 3x, ${Fixed_bg4x} 4x` },
  },
  Expansion: {
    fg: { src: Expansion,    srcSet: `${Expansion2x} 2x, ${Expansion3x} 3x, ${Expansion4x} 4x` },
    bg: { src: Expansion_bg, srcSet: `${Expansion_bg2x} 2x, ${Expansion_bg3x} 3x, ${Expansion_bg4x} 4x` },
  },
  Aligner: {
    fg: { src: Aligner,    srcSet: `${Aligner2x} 2x, ${Aligner3x} 3x, ${Aligner4x} 4x` },
    bg: { src: Aligner_bg, srcSet: `${Aligner_bg2x} 2x, ${Aligner_bg3x} 3x, ${Aligner_bg4x} 4x` },
  },
  Model: {
    fg: { src: Model,    srcSet: `${Model2x} 2x, ${Model3x} 3x, ${Model4x} 4x` },
    bg: { src: Model_bg, srcSet: `${Model_bg2x} 2x, ${Model_bg3x} 3x, ${Model_bg4x} 4x` },
  },
  Generic: {
    fg: { src: Overig,          srcSet: `${Overig2x} 2x, ${Overig3x} 3x, ${Overig4x} 4x` },
    bg: { src: DentalOverig_bg, srcSet: `${DentalOverig_bg2x} 2x, ${DentalOverig_bg3x} 3x, ${DentalOverig_bg4x} 4x` },
  },
};

const FALLBACK = IMAGE_SETS.Generic;

export const getImageSetForIconType           = (iconType) => (IMAGE_SETS[iconType] ?? FALLBACK).fg;
export const getBackgroundImageSetForIconType = (iconType) => (IMAGE_SETS[iconType] ?? FALLBACK).bg;


// ---------------------------------------------------------------------------
// RestorationTypeID → IconType
//
// Ground truth = old getImageSetForWorktype buckets:
//
//  Fixed bucket    : FXA(FixedAppliance) DFA DMZ HRB HRR LTP MRP NNC QHX RBA RRB RRH SPM
//  Aligner bucket  : ALG(Aligners) ASP BLT(BleachingTray) DSP DSPT
//                    IBT(IndirectBondingTray) MGD(Mouthguard)
//                    OIR(OrthodonticInvisibleRetainer) SPL(Splint) TRIO
//                    + ClearOverlay (no old code, same family)
//  Expansion bucket: EXP(ExpansionPlate) ACT(Activator) MRA(MandibularRepositioningAppliance)
//                    RNP(RetentionPlate) SGG(SurgicalGuide)
//                    BEP BIO DAC DUC EVA FRK HOA LRM MNB NTA OPA TAP TWB UAP VBK
//                    (all map to Activator or ExpansionPlate sub-types)
//  Model bucket    : MOD(Model) STM VTM WKM
//                    + ImpressionTray / WaxUp / ImplantPlanning (no old codes)
//  Wire bucket     : WRR(WireRetainer) AWR PKR
//
// CRITICAL: categoryID fallbacks must come LAST, after all explicit type
// checks. Previously they fired too early, causing Activator / RetentionPlate
// / OrthodonticInvisibleRetainer etc. to incorrectly return 'Fixed' because
// their categoryID was 'Orthodontics' or 'Fixed'.
// ---------------------------------------------------------------------------

export function getIconTypeForRestoration(restoration) {
  if (!restoration || typeof restoration !== 'object') return 'Generic';

  const {
    RestorationTypeID: type,
    RestorationDetailID: detail,
    CategoryID: category,
  } = restoration;

  // ── Dental: implant ──────────────────────────────────────────────────────
  if (type === 'ImplantBridge') return 'ImplantBridge';
  if (type === 'ImplantCrown')  return 'ImplantCrown';

  // ── Dental: fixed prosthetics ────────────────────────────────────────────
  if (type === 'Bridge') return 'Bridge';
  if (type === 'Crown')  return 'Crown';

  // ── Dental: dentures ─────────────────────────────────────────────────────
  if (type === 'Denture' || type === 'ImplantDenture') {
    if (detail === 'Partial') return 'PartialDenture';
    return 'FullDenture'; // Full / Telescope / bare — jaw resolved in getHighestIconType
  }

  // ── Wire bucket: WRR AWR PKR ─────────────────────────────────────────────
  if (type === 'WireRetainer') return 'Wire';

  // ── Aligner bucket: ALG ASP BLT DSP DSPT IBT MGD OIR SPL TRIO ───────────
  // DSP/ASP/DSPT → Splint (DamonSplint detail)
  // TRIO         → OrthodonticInvisibleRetainer (TrimlineOIR detail)
  if (type === 'Aligners')                     return 'Aligner'; // ALG
  if (type === 'ClearOverlay')                 return 'Aligner'; // no old code, closest family
  if (type === 'Splint')                       return 'Aligner'; // SPL ASP DSP DSPT
  if (type === 'BleachingTray')                return 'Aligner'; // BLT
  if (type === 'Mouthguard')                   return 'Aligner'; // MGD
  if (type === 'IndirectBondingTray')          return 'Aligner'; // IBT
  if (type === 'OrthodonticInvisibleRetainer') return 'Aligner'; // OIR TRIO

  // ── Expansion bucket: EXP BEP ACT MRA RNP SGG ────────────────────────────
  // BEP → ExpansionPlate + BertoniPlate detail (NOT Activator)
  // SGG → SurgicalGuide (Expansion bucket, NOT ImplantBridge)
  if (type === 'ExpansionPlate')                   return 'Expansion'; // EXP BEP
  if (type === 'Activator')                        return 'Expansion'; // ACT BIO DAC DUC EVA FRK HOA LRM MNB NTA OPA TAP TWB UAP VBK
  if (type === 'MandibularRepositioningAppliance') return 'Expansion'; // MRA
  if (type === 'RetentionPlate')                   return 'Expansion'; // RNP
  if (type === 'SurgicalGuide')                    return 'Expansion'; // SGG

  // ── Fixed bucket: FXA + DFA DMZ HRB HRR LTP MRP NNC QHX RBA RRB RRH SPM ─
  if (type === 'FixedAppliance') return 'Fixed'; // FXA

  // ── Model bucket: MOD STM VTM WKM ────────────────────────────────────────
  if (type === 'Model')           return 'Model'; // MOD
  if (type === 'ImpressionTray')  return 'Model'; // no old code, model family
  if (type === 'BiteRegistration') return 'Model'; // same icon as ImpressionTray
  if (type === 'WaxUp')           return 'Model'; // no old code, model family
  if (type === 'ImplantPlanning') return 'ImplantBridge'; // implant family

  // ── categoryID fallbacks — MUST be last ──────────────────────────────────
  // Only fires for types not matched above. Prevents explicit types like
  // Activator (category=Orthodontics) from being wrongly overridden to Fixed.
  if (type === 'OrthodonticAppliance') return 'Fixed'; // no old code; Fixed is closest
  if (category === 'Fixed')            return 'Fixed';
  if (category === 'Orthodontics')     return 'Fixed';

  return 'Generic';
}


// ---------------------------------------------------------------------------
// Highest icon type across multiple restorations
// ---------------------------------------------------------------------------

// Dental specifics win over ortho generics.
// Within ortho: Wire > Fixed > Expansion > Aligner > Model > Generic
// FullDenture variants use special jaw logic below.
const ICON_HIERARCHY = [
  'ImplantBridge',
  'Bridge',
  'ImplantCrown',
  'Crown',
  'PartialDenture',
  'FullDenture',      // sentinel — triggers jaw logic
  'FullDentureLower', // only via jaw logic
  'FullDentureUpper', // only via jaw logic
  'Wire',
  'Fixed',
  'Expansion',
  'Aligner',
  'Model',
  'Generic',
];

export function getHighestIconType(restorations) {
  let parsed = restorations;
  if (typeof restorations === 'string') {
    try { parsed = JSON.parse(restorations); } catch { return 'Generic'; }
  }
  if (!Array.isArray(parsed) || parsed.length === 0) return 'Generic';

  const iconTypes = new Set(parsed.map(getIconTypeForRestoration));

  for (const icon of ICON_HIERARCHY) {
    if (icon === 'FullDenture') {
      const FULL_TYPES = new Set(['FullDenture', 'FullDentureLower', 'FullDentureUpper']);
      const matches = parsed.filter(r => FULL_TYPES.has(getIconTypeForRestoration(r)));
      if (matches.length === 0) continue;
      if (matches.length >= 2) return 'FullDenture';
      const jaw = matches[0].Jaw?.toLowerCase().trim();
      if (jaw === 'lower') return 'FullDentureLower';
      if (jaw === 'upper') return 'FullDentureUpper';
      return 'FullDenture';
    }
    if (icon === 'FullDentureLower' || icon === 'FullDentureUpper') continue;
    if (iconTypes.has(icon)) return icon;
  }

  return 'Generic';
}


// ---------------------------------------------------------------------------
// Legacy: old ortho worktype-code path
// Kept for any callers that still pass raw worktype codes.
// ---------------------------------------------------------------------------

export const worktypeMap = {
  WRR: "Wire",
  SPL: "Splint",
  SGG: "Surgical",
  RNP: "Retention",
  OIR: "OIR",
  MRA: "MRA",
  MOD: "Model",
  MGD: "Mouthguard",
  IBT: "IBT",
  FXA: "Fixed",
  EXP: "Expansion",
  BLT: "Bleach",
  ALG: "Aligner",
  ACT: "Activator",
};

export const getImageSetForWorktype = (worktype) => {
  switch (worktype) {
    case "DFA": case "DMZ": case "FXA": case "HRB": case "HRR":
    case "LTP": case "MRP": case "NNC": case "QHX": case "RBA":
    case "RRB": case "RRH": case "SPM":
      return { src: Fixed, srcSet: `${Fixed2x} 2x, ${Fixed3x} 3x, ${Fixed4x} 4x` };
    case "ALG": case "ASP": case "BLT": case "DSP": case "DSPT":
    case "IBT": case "MGD": case "OIR": case "SPL": case "TRIO":
      return { src: Aligner, srcSet: `${Aligner2x} 2x, ${Aligner3x} 3x, ${Aligner4x} 4x` };
    case "BEP": case "BIO": case "DAC": case "DUC": case "EVA":
    case "EXP": case "FRK": case "HOA": case "LRM": case "MNB":
    case "MRA": case "NTA": case "OPA": case "RNP": case "SGG":
    case "TAP": case "TWB": case "UAP": case "VBK": case "ACT":
      return { src: Expansion, srcSet: `${Expansion2x} 2x, ${Expansion3x} 3x, ${Expansion4x} 4x` };
    case "MOD": case "STM": case "VTM": case "WKM":
      return { src: Model, srcSet: `${Model2x} 2x, ${Model3x} 3x, ${Model4x} 4x` };
    case "AWR": case "PKR": case "WRR":
      return { src: Wire, srcSet: `${Wire2x} 2x, ${Wire3x} 3x, ${Wire4x} 4x` };
    default:
      return { src: Overig, srcSet: `${Overig2x} 2x, ${Overig3x} 3x, ${Overig4x} 4x` };
  }
};

export const getBackgroundImageSetForWorktype = (worktype) =>
  getBackgroundImageSetForIconType(
    getHighestIconType([{ RestorationTypeID: worktypeMap[worktype] ?? worktype }])
  );


// ---------------------------------------------------------------------------
// Display name helpers (unchanged)
// ---------------------------------------------------------------------------

export function getWorktypeDisplayName(restoration) {
  if (!restoration || typeof restoration !== 'object') return 'Generic';
  const { RestorationTypeID: type, RestorationDetailID: detail } = restoration;

  if (type === 'Crown') {
    if (detail === 'Full')       return 'Crown';
    if (detail === 'Partial')    return 'Partial Crown';
    if (detail === 'Veneer')     return 'Veneer';
    if (detail === 'Temporary')  return 'Temporary Crown';
    if (detail === 'Telescope')  return 'Telescope Crown';
    if (detail === 'Post')       return 'Post Crown';
    return 'Crown';
  }
  if (type === 'Bridge') {
    if (detail === 'Temporary') return 'Temporary Bridge';
    return 'Bridge';
  }
  if (type === 'ImplantCrown') {
    if (detail === 'Temporary') return 'Temporary Implant Crown';
    return 'Implant Crown';
  }
  if (type === 'ImplantBridge') {
    if (detail === 'Temporary') return 'Temporary Implant Bridge';
    return 'Implant Bridge';
  }
  if (type === 'ImplantDenture')  return 'Implant Denture';
  if (type === 'Denture') {
    if (detail === 'Full')      return 'Full Denture';
    if (detail === 'Partial')   return 'Partial Denture';
    if (detail === 'Telescope') return 'Telescope Denture';
    return 'Denture';
  }
  if (type === 'WireRetainer')  return 'Wire Retainer';
  if (type === 'ClearOverlay')  return 'Clear Overlay';
  if (type === 'Splint') {
    if (detail === 'DamonSplint') return 'Damon Splint';
    return 'Splint';
  }
  if (type === 'BleachingTray')  return 'Bleaching Tray';
  if (type === 'Mouthguard')     return 'Mouthguard';
  if (type === 'SurgicalGuide')  return 'Surgical Guide';
  if (type === 'Aligners')       return 'Aligners';
  if (type === 'MandibularRepositioningAppliance') return 'Mandibular Repositioning Appliance';
  if (type === 'IndirectBondingTray')              return 'Indirect Bonding Tray';
  if (type === 'Model') {
    if (detail === 'StudyModel')   return 'Study Model';
    if (detail === 'WorkModel')    return 'Work Model';
    if (detail === 'VirtualModel') return 'Virtual Model';
    return 'Model';
  }
  if (type === 'ImpressionTray')  return 'Impression Tray';
  if (type === 'BiteRegistration') return 'Bite Registration';
  if (type === 'Activator') {
    if (detail === 'Bionator')          return 'Activator • Bionator';
    if (detail === 'Ducovator')         return 'Activator • Ducovator';
    if (detail === 'EVAA')              return 'Activator • EVAA';
    if (detail === 'Frankel')           return 'Activator • Frankel';
    if (detail === 'HalfOpenActivator') return 'Activator • Half Open';
    if (detail === 'LRM')               return 'Activator • LRM';
    if (detail === 'MonoBlock')         return 'Activator •  Mono Block';
    if (detail === 'NewTAppliance')     return 'Activator • New T-Appliance';
    if (detail === 'OpenActivator')     return 'Activator • Open';
    if (detail === 'TAppliance')        return 'Activator • T-Appliance';
    if (detail === 'TwinBlock')         return 'Activator • Twin Block';
    if (detail === 'UAppliance')        return 'Activator • U-Appliance';
    if (detail === 'VanBeek')           return 'Activator • Van Beek';
    return 'Activator';
  }
  if (type === 'ExpansionPlate') {
    if (detail === 'BertoniPlate') return 'Expansion Bertoni Plate';
    return 'Expansion Plate';
  }
  if (type === 'FixedAppliance') {
    if (detail === 'DistalizerMesializer') return 'Fixed • Distalizer/Mesializer';
    if (detail === 'Herbst')               return 'Fixed • Herbst';
    if (detail === 'HerbstRPERME')         return 'Fixed • Herbst RPERME';
    if (detail === 'LLATPA')               return 'Fixed • LLA/TPA';
    if (detail === 'MARPE')                return 'Fixed • MARPE';
    if (detail === 'Nance')                return 'Fixed • Nance';
    if (detail === 'RPERMEBanded')         return 'Fixed • RPE/RME Banded';
    if (detail === 'RPERMEBonded')         return 'Fixed • RPE/RME Bonded';
    if (detail === 'RPERMEHybrid')         return 'Fixed • RPE/RME Hybrid';
    if (detail === 'SpaceMaintainer')      return 'Fixed • Space Maintainer';
    if (detail === 'QuadHelix')            return 'Fixed • Quad Helix';
    return 'Fixed Appliance';
  }
  if (type === 'RetentionPlate')               return 'Retention Plate';
  if (type === 'OrthodonticInvisibleRetainer') return 'Orthodontic Invisible Retainer';
  if (type === 'OrthodonticAppliance')         return 'Orthodontics';
  if (type === 'WaxUp')                        return 'Wax-up';

  return 'Unknown';
}

export function getChipName(restoration) {
  if (!restoration || typeof restoration !== 'object') return 'Generic';
  const { RestorationTypeID: type } = restoration;

  if (type === 'Crown')                            return 'Crown';
  if (type === 'Bridge')                           return 'Bridge';
  if (type === 'ImplantCrown')                     return 'Implant Crown';
  if (type === 'ImplantBridge')                    return 'Implant Bridge';
  if (type === 'ImplantPlanning')                  return 'Implant Planning';
  if (type === 'ImplantDenture')                   return 'Implant Denture';
  if (type === 'Denture')                          return 'Denture';
  if (type === 'WireRetainer')                     return 'Wire';
  if (type === 'ClearOverlay')                     return 'Overlay';
  if (type === 'Splint')                           return 'Splint';
  if (type === 'BleachingTray')                    return 'Bleaching';
  if (type === 'Mouthguard')                       return 'Guard';
  if (type === 'SurgicalGuide')                    return 'Guide';
  if (type === 'Aligners')                         return 'Aligners';
  if (type === 'MandibularRepositioningAppliance') return 'MRA';
  if (type === 'IndirectBondingTray')              return 'IBT';
  if (type === 'Model')                            return 'Model';
  if (type === 'ImpressionTray')                   return 'Tray';
  if (type === 'BiteRegistration')                 return 'Bite';
  if (type === 'Activator')                        return 'Activator';
  if (type === 'ExpansionPlate')                   return 'Expansion';
  if (type === 'FixedAppliance')                   return 'Fixed';
  if (type === 'RetentionPlate')                   return 'Retention';
  if (type === 'OrthodonticInvisibleRetainer')     return 'OIR';
  if (type === 'OrthodonticAppliance')             return 'Orthodontics';
  if (type === 'WaxUp')                            return 'Wax-up';

  return 'Unknown';
}

export function getBridgeUnitName(restoration) {
  if (!restoration || typeof restoration !== 'object') return 'Unit';
  const { RestorationTypeID: type, RestorationDetailID: detail } = restoration;
  if (detail === 'Pontic')     return 'Pontic';
  if (type === 'ImplantCrown') return 'Implant';
  return 'Unit';
}

export function getMaterialName(restoration) {
  if (!restoration || typeof restoration !== 'object') return '';
  const { MaterialID: materialID } = restoration;
  if (materialID === 'LithiumDisilicate') return 'Lithium Disilicate';
  return materialID;
}

export { Dot };